var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFaq = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1001 9.09961H46.9001V36.8996H16.7385L9.1001 44.0811V9.09961ZM10.9001 10.8996V39.9181L16.0252 35.0996H45.1001V10.8996H10.9001Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3999 29.5996C29.3999 30.1519 28.9522 30.5996 28.3999 30.5996C27.8476 30.5996 27.3999 30.1519 27.3999 29.5996C27.3999 29.0473 27.8476 28.5996 28.3999 28.5996C28.9522 28.5996 29.3999 29.0473 29.3999 29.5996Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4 29.4992C28.3448 29.4992 28.3 29.544 28.3 29.5992C28.3 29.6544 28.3448 29.6992 28.4 29.6992C28.4552 29.6992 28.5 29.6544 28.5 29.5992C28.5 29.544 28.4552 29.4992 28.4 29.4992ZM26.5 29.5992C26.5 28.5499 27.3507 27.6992 28.4 27.6992C29.4493 27.6992 30.3 28.5499 30.3 29.5992C30.3 30.6486 29.4493 31.4992 28.4 31.4992C27.3507 31.4992 26.5 30.6486 26.5 29.5992Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0533 17.7477C25.2949 18.241 24.9001 18.8681 24.9001 19.6022L23.1001 19.6022C23.1001 18.0971 23.9553 16.965 25.0719 16.2387C26.175 15.5213 27.5935 15.1481 28.9713 15.104C30.3466 15.0601 31.7874 15.341 32.9168 16.0515C34.0825 16.7848 34.9001 17.9755 34.9001 19.6022C34.9001 20.9751 34.1031 21.8566 33.2519 22.4284C32.6305 22.8458 31.8666 23.1677 31.2656 23.4209C31.0935 23.4935 30.9347 23.5604 30.7965 23.6223C29.7008 24.1129 29.1858 25.0648 29.1858 25.9996H27.3858C27.3858 24.3754 28.2994 22.7682 30.0608 21.9795C30.2745 21.8838 30.4843 21.7951 30.6887 21.7087C31.2572 21.4684 31.7855 21.245 32.2482 20.9342C32.8256 20.5464 33.1001 20.1484 33.1001 19.6022C33.1001 18.6698 32.6677 18.0213 31.9584 17.5751C31.2128 17.106 30.1537 16.8671 29.0289 16.9031C27.9067 16.939 26.8252 17.2456 26.0533 17.7477Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8999 23.0996H45.0999V35.0996H19.0998V48.204H47.434L54.8999 56.304V23.0996ZM53.0999 24.8996V51.6952L48.2229 46.404H20.8998V36.8996H46.8999V24.8996H53.0999Z",
    fill: "#1C1C1C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaq);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FAQ.c8f847d69645dff6231ce8b5eccabc00.svg";